<template>
  <label class="inline-flex items-center cursor-pointer">
    <input v-model="model" type="checkbox" class="sr-only peer" />
    <div
      class="relative w-9 h-5 bg-gray-200 rounded-full peer peer-focus:ring-3 peer-focus:ring-teal-300 peer-checked:after:translate-x-full peer-checked:rtl:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:inset-s-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-teal-700"
    ></div>
    <span class="ms-3 text-sm font-medium text-gray-900"
      ><slot>{{ label }}</slot></span
    >
  </label>
</template>
<script setup>
defineProps(['label'])
const model = defineModel()
</script>
